import React from 'react';
import PropTypes from 'prop-types';

import LabelDetails from '../../../../attendee/detail/components/label-details/labelDetails';
import { useTranslation } from 'react-i18next';
import OrderModel from '../../../models/orderModel';
import { GetPaymentTypeLabel } from '../../../list/list';

export default function PaymentMethod({ className = '', order, params = {} }) {
    const { t } = useTranslation();
    const [paymentMethod, setPaymentMethod] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    const isDisplayable = React.useMemo(() => {
        return order.status === 'valid' && ['weez_web', 'weez_ticketoffice'].includes(order.origin);
    }, [order]);

    const paymentMethodLabel = response => {
        let _paymentMethodLabel = t('ticket.common.paymentMethod.unknown');

        if (!response['payments'] || (Array.isArray(response['payments']) && !response['payments'].length)) {
            return _paymentMethodLabel;
        }
        if (response['payments'].length === 1) {
            if (response['payments'][0]['default_payment_mode']) return t(`ticket.common.paymentMethod.${response['payments'][0]['payment_mode_label']}`);
            else return response['payments'][0]['payment_mode_label'];
        }

        return t('ticket.common.paymentMethod.multimodal_payment');
    };

    React.useEffect(() => {
        if (isDisplayable && !paymentMethod && !loading && !order?.payment_type) {
            if (order.internal_transaction) {
                setPaymentMethod(t('ticket.common.paymentMethod.online_payment'));
            }

            if (!order.internal_transaction) {
                setLoading(true);
                OrderModel.payment_method(order, params)
                    .then(response => setPaymentMethod(paymentMethodLabel(response.response)))
                    .catch(() => {
                        setPaymentMethod(t('ticket.common.paymentMethod.unknown'));
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        }
    }, [paymentMethod, paymentMethodLabel, params, order, loading, isDisplayable]);

    if (!isDisplayable) {
        return null;
    }

    const paymentMethodValue = React.useMemo(() => (order.origin === 'weez_web' && order.payment_type ? GetPaymentTypeLabel(order.payment_type, t) : paymentMethod), [
        order,
        paymentMethod
    ]);

    return (
        <LabelDetails title={t('ticket.common.paymentMethod.label')} className={`${'payment_method'} ${className}`} loading={loading}>
            <span style={{ fontWeight: 'bold' }}>{paymentMethodValue}</span>
        </LabelDetails>
    );
}

PaymentMethod.propTypes = {
    order: PropTypes.object.isRequired,
    className: PropTypes.string,
    params: PropTypes.object
};
